var map = {
	"./downLoad.svg": 21125,
	"./fenshu.svg": 17134,
	"./pdf.svg": 70049,
	"./ppt.svg": 98935,
	"./user.svg": 66496,
	"./video.svg": 34874,
	"./video2.svg": 66628,
	"./word.svg": 51181,
	"./xlsx.svg": 75644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79692;